import { takeLatest } from 'redux-saga/effects';
import { getAccountPath } from '../../utils/firebase';
import { fetchReportRoutine } from '../routines';
import { fetchSaga } from './helper';

function* watchFetchReportSaga() {
  yield takeLatest(fetchReportRoutine.TRIGGER, fetchSaga(fetchReportRoutine, (payload) => getAccountPath('reports', `jobreport/${payload.jobId}`))); // TODO review url
}

export {
  watchFetchReportSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/reports.js